import { render, staticRenderFns } from "./UnlockGold.vue?vue&type=template&id=4884cbd2&scoped=true&"
import script from "./UnlockGold.vue?vue&type=script&lang=js&"
export * from "./UnlockGold.vue?vue&type=script&lang=js&"
import style0 from "./UnlockGold.vue?vue&type=style&index=0&id=4884cbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884cbd2",
  null
  
)

export default component.exports